import { render, staticRenderFns } from "./dj-square.vue?vue&type=template&id=fb72d452&scoped=true&"
import script from "./dj-square.vue?vue&type=script&lang=js&"
export * from "./dj-square.vue?vue&type=script&lang=js&"
import style0 from "./dj-square.vue?vue&type=style&index=0&id=fb72d452&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb72d452",
  null
  
)

export default component.exports